import React from 'react'
import PropTypes from 'prop-types'

import ContentCallout from 'experienceComponents/ContentCallout'
import { checkIfLessonIsComplete } from 'utils/highschoolHelpers'

const HighSchoolTrainingLinkSummaries = ({
  instructorData,
  linkSummaries = [],
}) => {
  const filteredLinkSummaries = linkSummaries.filter(
    summary => summary.description && summary.displayTitle,
  )

  return filteredLinkSummaries.map((summary, index) => {
    const uniqueId = `summary-${index + 1}`
    const { displayTitle, description, route, courseNodeConnector } =
      summary || {}
    const { courseNodeEntryPoint } = courseNodeConnector || {}
    const keysToSearch = Object.keys(instructorData || {})
    const arrayToSearch = []

    for (const key of keysToSearch) {
      if (
        Object.prototype.hasOwnProperty.call(
          instructorData[key],
          'lesson_nodes',
        )
      ) {
        arrayToSearch.push(...instructorData[key].lesson_nodes)
      }
    }

    const { isComplete } =
      checkIfLessonIsComplete(arrayToSearch, courseNodeEntryPoint) || {}

    return (
      <ContentCallout
        body={description}
        dataTestId={uniqueId}
        isComplete={isComplete}
        isHighSchoolTrainingPage
        key={uniqueId}
        route={route}
        title={displayTitle}
      />
    )
  })
}

HighSchoolTrainingLinkSummaries.propTypes = {
  instructorData: PropTypes.object,
  linkSummaries: PropTypes.arrayOf(PropTypes.object),
}

export default HighSchoolTrainingLinkSummaries
